export const getTopicsComplete = (interactionsInTopics, interactionsSeen) => {
  const temp = {};
  Object.keys(interactionsInTopics).forEach(key => {
    const interactions = interactionsInTopics[key];
    temp[key] = interactions.every(i => {
      return interactionsSeen.includes(i.id);
    });
  });

  return temp;
};
